import { RoleListState } from "./RoleList-State";

export default function roleListReducer(state = RoleListState, action) {
  let { data } = JSON.parse(JSON.stringify(state));
  let { name, value } = action;

  switch (action.type) {
    case "TOGGLE-ROLE-LIST-FILTER":
      if (name === `sort_by`) {
        if (data.params.sort_by === value) {
          data.params.sort_order =
            data.params.sort_order === `desc` ? `asc` : `desc`;
        }
      }
      let toggle = true;
      if (toggle) {
        if (name === "limit") {
          data.params.page = 1;
        }
        data.params[name] = value;
      }
      return { ...state, data };

    case "TOGGLE-RESET-ROLES":
      data.params.page = 1;
      data.params.q = "";
      data.payload.initialLoading = true;
      return { ...state, data };

    default:
      return state;
  }
}
